import { Text } from '@/components/ui/text';
import * as React from 'react';
import { Pressable, View } from 'react-native';

interface TourDigestBannerProps {
  visible: boolean;
  onPress: () => void;
}

function TourDigestBanner({ visible, onPress }: TourDigestBannerProps) {
  if (!visible) {
    return null;
  }

  return (
    <View className="mx-4 mb-3 bg-card border border-border rounded-xl p-4 flex-row justify-between">
      <Text className="text-card-foreground text-sm mr-3">
        {"We've added some new things since you were last here."}
      </Text>
      <Pressable
        onPress={onPress}
        accessibilityLabel="Take a look"
        accessibilityRole="button"
        className="bg-primary rounded-lg py-2 px-4"
      >
        <Text className="text-primary-foreground font-semibold text-sm">
          Take a look
        </Text>
      </Pressable>
    </View>
  );
}

export { TourDigestBanner };
export type { TourDigestBannerProps };

